"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternetAccount = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _mobxStateTree = require("mobx-state-tree");

var _configuration = require("../../configuration");

var _io = require("../../util/io");

var _mst = require("../../util/types/mst");

var InternetAccount = _mobxStateTree.types.model('InternetAccount', {
  id: _mst.ElementId,
  type: _mobxStateTree.types.string
}).views(function (self) {
  return {
    get name() {
      return (0, _configuration.getConf)(self, 'name');
    },

    get internetAccountId() {
      return (0, _configuration.getConf)(self, 'internetAccountId');
    },

    get tokenType() {
      return (0, _configuration.getConf)(self, 'tokenType');
    },

    get accountConfig() {
      return (0, _configuration.getConf)(self);
    },

    get toggleContents() {
      return null;
    },

    get SelectorComponent() {
      return undefined;
    },

    get selectorLabel() {
      return undefined;
    },

    handlesLocation: function handlesLocation(location) {
      return false;
    }
  };
}).actions(function (self) {
  return {
    openLocation: function openLocation(location) {
      return new _io.RemoteFileWithRangeCache(String(location.uri));
    },
    getPreAuthorizationInformation: function getPreAuthorizationInformation(location) {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", {
                  internetAccountType: self.type
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  };
});

exports.InternetAccount = InternetAccount;